<template>
    <div class="justify-center align-center">
        <v-card class="rounded-5 my-3" outlined>
            <v-card outlined class="rounded-5" height="65" color="#F9F9F9">
                <v-card-title>
                    <v-icon class="mr-3" color="primary">mdi-receipt-text-outline</v-icon>
                    Mis recibos
                </v-card-title>
            </v-card>
            <v-divider></v-divider>
            <v-row>
                <div class="primary pa-5 ma-4"></div>
            </v-row>

        </v-card>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
export default {
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            periodos: [
                { tipo: 1, mes: '01', anio: '2023' },
                { tipo: 1, mes: '02', anio: '2023' },
                { tipo: 1, mes: '03', anio: '2023' },
                { tipo: 1, mes: '04', anio: '2023' },
                { tipo: 1, mes: '05', anio: '2023' },
                { tipo: 1, mes: '06', anio: '2023' },
                { tipo: 1, mes: '07', anio: '2023' },
            ],
            select: ['Vuetify', 'Programming'],
            items: [
                'Programming',
                'Design',
                'Vue',
                'Vuetify',
            ],
        }
    },
    mounted() {

    },
    methods: {

    },
    computed: {

    }
};
</script>